import { render, staticRenderFns } from "./TransferContacts.vue?vue&type=template&id=0cd875d3&scoped=true"
import script from "./TransferContacts.vue?vue&type=script&lang=js"
export * from "./TransferContacts.vue?vue&type=script&lang=js"
import style0 from "./TransferContacts.vue?vue&type=style&index=0&id=0cd875d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd875d3",
  null
  
)

export default component.exports